import { useState } from 'react';
import { useNotifications } from '@decisiv/ui-components';
import { fetchAccounts } from '../services';

function useAccounts(csrfToken) {
  const [accounts, setAccounts] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const { notify } = useNotifications();

  async function getAccounts(query, page, sortBy, sortOrder) {
    setLoading(true);
    try {
      const response = await fetchAccounts(
        csrfToken,
        query,
        page,
        sortBy,
        sortOrder,
      );

      const parsedResponse = await response.json();
      setAccounts(parsedResponse.accounts);
      setTotalPages(parsedResponse.total_pages);
      setLoading(false);
    } catch (error) {
      console.error('error', error);
      notify({
        id: 'notify-error',
        intent: 'danger',
        title: error,
        duration: 15000,
        onClose: () => {},
      });
      setLoading(false);
    }
  }

  function clearAccounts() {
    setAccounts([]);
    setTotalPages(0);
  }

  return {
    getAccounts,
    clearAccounts,
    loading,
    accounts,
    totalPages,
  };
}

export default useAccounts;
